import { color } from '@thiememeulenhoff/lit-sdk';
import { ScoreLevel } from '@thiememeulenhoff/types';
import { CSSResult } from 'lit';

export const SCORE_LEVEL_COLOR_MAP: Record<ScoreLevel, CSSResult> = {
  [ScoreLevel.Poor]: color('pink', 600),
  [ScoreLevel.Unsatisfactory]: color('orange', 600),
  [ScoreLevel.Marginal]: color('orange', 600),
  [ScoreLevel.Satisfactory]: color('green', 600),
  [ScoreLevel.Excellent]: color('green', 600),
};

export const SCORE_LEVEL_COLOR_HOVER_MAP: Record<ScoreLevel, CSSResult> = {
  [ScoreLevel.Poor]: color('pink', 700),
  [ScoreLevel.Unsatisfactory]: color('orange', 700),
  [ScoreLevel.Marginal]: color('orange', 700),
  [ScoreLevel.Satisfactory]: color('green', 700),
  [ScoreLevel.Excellent]: color('green', 700),
};

export const SCORE_LEVEL_TEXT_COLOR_MAP: Record<ScoreLevel, CSSResult> = {
  [ScoreLevel.Poor]: color('white'),
  [ScoreLevel.Unsatisfactory]: color('white'),
  [ScoreLevel.Marginal]: color('white'),
  [ScoreLevel.Satisfactory]: color('white'),
  [ScoreLevel.Excellent]: color('white'),
};

export const SCORE_LEVEL_NEUTRAL_TEXT_COLOR_MAP: Record<ScoreLevel, CSSResult> =
  {
    [ScoreLevel.Poor]: color('pink', 600),
    [ScoreLevel.Unsatisfactory]: color('orange', 600),
    [ScoreLevel.Marginal]: color('orange', 600),
    [ScoreLevel.Satisfactory]: color('green', 600),
    [ScoreLevel.Excellent]: color('green', 600),
  };

export const SCORE_LEVEL_ICON_MAP: Record<ScoreLevel, string> = {
  [ScoreLevel.Poor]: 'close',
  [ScoreLevel.Unsatisfactory]: 'wave-triangle',
  [ScoreLevel.Marginal]: 'wave-triangle',
  [ScoreLevel.Satisfactory]: 'check',
  [ScoreLevel.Excellent]: 'check',
};
